/* eslint-disable react/no-array-index-key */
import React from 'react'

// Components
import NavLink from 'components/shared/NavLink'
import Submenu from 'components/layout/Header/Submenu'

// Images
import Chevron from 'img/chevron.inline.svg'

// Third Party
import styled, { css } from 'styled-components'
import { motion, AnimatePresence } from 'framer-motion'

const Item = styled(motion.li)`
  & > div {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  & div > a {
    color: ${(props) => props.theme.color.dark};
    font-weight: ${({ theme }) => theme.font.weight.light};
    font-size: 16px;
    border-bottom: 3px solid transparent;
    transition: all 0.2s ease-in-out;

    &[aria-current] {
      color: ${({ theme }) => theme.color.primary};
      font-weight: ${({ theme }) => theme.font.weight.bold};
    }

    &:hover {
      border-bottom-color: ${({ theme }) => theme.color.primary};
    }
  }

  @media screen and (max-width: 991px) {
    padding: 4px 0;
    list-style: none;

    & div > a {
      font-size: 40px;
      line-height: 40px;
      font-weight: ${({ theme }) => theme.font.weight.bold};

      &:hover {
        border-bottom-color: transparent;
        opacity: 0.6;
      }
    }
  }
`

interface MenuProps {
  fields: GatsbyTypes.WpComponent
}

const SvgWrapper = styled.div<{ open: boolean }>`
  margin-left: 15px;

  @media (min-width: 992px) {
    display: none;
  }

  & > svg {
    transition: all 0.3s ease;

    ${({ open }) =>
      open
        ? css`
            transform: rotate(180deg);
          `
        : css`
            transform: rotate(0deg);
          `};
  }
`

const Menu: React.FC<MenuProps> = ({ fields }) => {
  const [open, setOpen] = React.useState<number>(-1)

  return (
    <>
      {fields.header?.menuHeader?.map((l, index) => (
        <Item
          onHoverStart={() => setOpen(index)}
          onHoverEnd={() => setOpen(-1)}
          key={index}
        >
          <div>
            <NavLink to={l?.link?.url || '/'}>{l?.link?.title}</NavLink>
            {l?.submenu && (
              <SvgWrapper open={open === index}>
                <motion.div
                  onTap={
                    open === index ? () => setOpen(-1) : () => setOpen(index)
                  }
                >
                  <Chevron />
                </motion.div>
              </SvgWrapper>
            )}
          </div>
          {l?.submenu && (
            <AnimatePresence>
              {open === index && <Submenu fields={l.submenu} />}
            </AnimatePresence>
          )}
        </Item>
      ))}
    </>
  )
}

export default Menu
